// extracted by mini-css-extract-plugin
export default {"root":"LogoutButton_root__RdQ0p","icon":"LogoutButton_icon__KLvDD"};